import { messageConstants } from "../constants";
import { showToast } from "../components";

const getMessageByPath = (path) => {
  return path.split('.').reduce((obj, key) => obj && obj[key], messageConstants) || "Message not found";
};

export function showToastMessage(type="error",messageKey) {
  const message = getMessageByPath(messageKey);
  return showToast(message,type);
}

